import React from 'react';
import { Check } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    emoji: '📘',
    num: '1',
    title: 'El Sistema Base',
    subtitle: 'Método Domingo de Rescate: organizá la semana en 2 horas',
    color: '#2563EB'
  }, {
    emoji: '📗',
    num: '2',
    title: 'Recetario Cero Estufa/Horno',
    subtitle: '30 recetas sin cocinar nada',
    color: '#16A34A'
  }, {
    emoji: '📙',
    num: '3',
    title: 'Niños/Niñas Selectivos',
    subtitle: 'Cuando tu hijo/hija rechaza casi todo',
    color: '#EA580C'
  }, {
    emoji: '📕',
    num: '4',
    title: 'Viandas Express Lunes a Viernes',
    subtitle: 'Una vianda distinta por día en menos de 15 minutos',
    color: '#EAB308'
  }, {
    emoji: '📓',
    num: '5',
    title: 'Batch Cooking',
    subtitle: 'Cocinar una vez, resolver toda la semana',
    color: '#DC2626'
  }, {
    emoji: '📔',
    num: '6',
    title: 'Presupuesto Inteligente',
    subtitle: 'Gastar menos, desperdiciar menos, resolver más',
    color: '#C4B5FD'
  }];
  const includes = ['Recetas y soluciones listas desde el primer día', 'Lenguaje inclusivo: niño/niña, hijo/hija, papá/mamá', 'Español neutro para cualquier país hispanohablante', 'Adaptado para estufa/horno según el país', 'Plantillas imprimibles incluidas'];
  return <section className="bg-cosmic-deep pt-1 pb-6 md:pt-2 md:pb-8 px-4" data-id="element-329" data-mp="27q5z7h36mhqn">
      <div className="max-w-6xl mx-auto" data-id="element-330" data-mp="22ye7v4c7c7zg">
        {/* Brand header */}
        <div className="text-center mb-6" data-id="element-331" data-mp="1yx2i8ytbvmr9">
          <h2 className="font-display font-black tracking-tight leading-[1.05]" data-id="element-332" data-mp="1yxud27f3pggh">
            <span className="block text-white text-3xl md:text-6xl" data-id="element-333" data-mp="1tyr7mlv7l87z">
              MEGAPACK VIANDA
            </span>
            <span className="block text-gold text-3xl md:text-6xl" data-id="element-334" data-mp="1oxjz2kl8s509">
              RESUELTA
            </span>
          </h2>
          <div className="mt-3 inline-block bg-gold/15 border border-gold/40 text-gold px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm tracking-widest uppercase" data-id="element-335" data-mp="1k0k0svumw6jp">
            ✨ El sistema para padres separados
          </div>
          <p className="text-white text-[13px] md:text-base font-medium leading-snug mt-4 max-w-xl mx-auto" data-id="element-336" data-mp="11brhni3k7igy">
            6 tomos organizados + 5 bonos estratégicos para que puedas usar
            desde hoy
          </p>
        </div>

        {/* Section title */}
        <div className="text-center mb-6 md:mb-8" data-id="element-337" data-mp="1t4qu9ugkqum5">
          <p className="font-bold uppercase tracking-widest text-orange text-xl md:text-2xl mb-3" data-id="element-338" data-mp="1y20gz2ckws6a">
            📦 QUÉ RECIBÍS
          </p>
          <div className="block w-full bg-gradient-to-r from-gold via-gold-2 to-gold border-2 border-gold rounded-full px-3 md:px-8 py-3 md:py-4 shadow-[0_0_40px_rgba(245,166,35,0.55)]" data-id="element-339" data-mp="1ka3rz767iye4">
            <h3 className="font-display font-black text-[#1a0533] text-xl md:text-4xl tracking-tight whitespace-nowrap" data-id="element-340" data-mp="2bzyts3b94gjo">
              🍱 6 TOMOS COMPLETOS
            </h3>
          </div>
        </div>

        {/* Tomos list — compact horizontal layout */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-6 max-w-3xl lg:max-w-6xl mx-auto" data-id="element-341" data-mp="epva3m8l9uw">
          {tomos.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.2)] border border-white/10 flex items-stretch" data-id="element-342" data-mp="f2b1i6eerp71" data-mpi={i}>
              <div className="w-1.5 shrink-0" style={{
            backgroundColor: t.color
          }} data-id="element-343" data-mp="3ilmd9ldet2br"></div>
              <div className="flex items-center gap-2.5 px-2.5 py-2 flex-grow" data-id="element-344" data-mp="3sjjys13vwl0o">
                <div className="text-xl shrink-0 leading-none" data-id="element-345" data-mp="3nhuleet6vv9f">{t.emoji}</div>
                <div className="flex flex-col justify-center min-w-0 flex-grow" data-id="element-346" data-mp="17r8dxsvxurrv">
                  <div className="text-[9px] md:text-[10px] font-bold tracking-widest uppercase leading-none mb-0.5" style={{
                color: t.color
              }} data-id="element-347" data-mp="12snc5p11g01b">
                    Tomo {t.num}
                  </div>
                  <h4 className="font-display font-bold text-[13px] md:text-sm text-white leading-[1.15]" data-id="element-348" data-mp="3hhvnamz83xk3">
                    {t.title}
                  </h4>
                  <p className="text-white/65 text-[10px] md:text-[11px] leading-snug mt-0.5" data-id="element-349" data-mp="3mi098siwhkhp">
                    {t.subtitle}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-white/5 backdrop-blur-sm rounded-xl p-3 md:p-5 border border-gold/20 shadow-[0_4px_24px_rgba(0,0,0,0.2)]" data-id="element-350" data-mp="4zyvpkm4xjia">
          <h3 className="font-display font-bold text-sm md:text-lg text-white mb-2 text-center" data-id="element-351" data-mp="93wx61yxn6ei">
            ✅ Cada tomo incluye:
          </h3>
          <ul className="space-y-1.5" data-id="element-352" data-mp="iz6ysolf5brr">
            {includes.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-353" data-mp="t3n8t1c7vynn" data-mpi={i}>
                <div className="w-4 h-4 rounded-full bg-check/15 flex items-center justify-center shrink-0" data-id="element-354" data-mp="t1u4hsp2tqit">
                  <Check className="w-2.5 h-2.5 text-check" strokeWidth={3} data-id="element-355" data-mp="o76m8bko1sco" />
                </div>
                <span className="text-white/85 text-[11px] md:text-sm leading-snug" data-id="element-356" data-mp="j7k9s4cnwg4x">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}